var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"80%","font-family":"Arial, sans-serif","transform":"rotate(90deg)"},attrs:{"id":"pdf-content"}},_vm._l((_vm.ui_setting.texts),function(item,textIndex){return _c('div',{key:'div1' + textIndex + item.id,staticStyle:{"position":"absolute","text-align":"center"},style:('left: ' +
      item.x * 1.3 +
      'px ;bottom: ' +
      item.y * 1.1 +
      'px;font-size: ' +
      item.fontSize +
      'pt;' +
      (item.isBold ? 'font-weight: bold;' : '') +
      (item.isUppercase ? 'text-transform: uppercase;' : '') +
      (_vm.selectedMBCard&&_vm.selectedMBCard.text == item.text ? 'color: blue;' : ''))},[_c('span',[_vm._v(" "+_vm._s(_vm.getText(item))+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }